const status = [
  { status: "Pending", id: 0 },
  { status: "Success", id: 1 },
  { status: "On Hold", id: 2 },
  { status: "Shipped", id: 3 },
  { status: "Refund", id: 4 },
  { status: "Cancel", id: 5 },
  { status: "Attempt", id: 6 },
  { status: "Return", id: 7 },
  { status: "Success", id: 8 },
  { status: "Refund-Attempt", id: 9 },
  { status: "Ready to Ship", id: 10 },
];

export default status;
